export default __webpack_public_path__ + "static/media/restaurant-8-rMIN.de14ec09.jpg";